import React, { useEffect, useState } from "react";
import { Card, Row, Col, Select } from "antd";
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
} from "recharts";
import { get } from "../../api/usersModule/httpClient";

const { Option } = Select;
const defaultFormData = {
  PercentInventory: 0,
};

export const Dashboard = ({ userName, project }) => {
  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const [skus, setSkus] = useState([]);
  const [selectedSku, setSelectedSku] = useState("");
  const [selectedReception, setSelectedReception] = useState("");
  const [lineChartDataMap, setLineChartDataMap] = useState({});
  const [lineChartDataMapFee, setLineChartDataMapFee] = useState({});
  const [lineChartDataMapDoc, setLineChartDataMapDoc] = useState({});
  const [BarChartDataMap, setBarChartDataMap] = useState({});
  const [BarChartDataMap2, setBarChartDataMap2] = useState({});
  const [receptions, setReceptions] = useState([]);
  const TOTAL_UNITS_RECEPTION = "";
  const TOTAL_UNITS_QUALITY_RECEPTION = "";
  const TOTAL_WIDTH = 650;
  const TOTAL_SERVICE_FEE = 0;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obtener datos de SKU
        const skuResponse = await get(`/skus?Nit=${project}&Lista=True`);
        setSkus(skuResponse.items);

        // Obtener datos de recepciones
        const ReceptionResponse = await get(
          `/receptions?Nit=${project}&List=True`
        );
        setReceptions(ReceptionResponse.items);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [project]);

  useEffect(() => {
    const fetchSkuData = async () => {
      if (selectedSku !== "") {
        try {
          const skuDataResponse = await get(
            `/skus?Nit=${selectedSku.split("/*-/")[1]}&skusHistory=true&CodeSap=${selectedSku.split("/*-/")[0]}&limitDash=true`
          );
          const skuData = skuDataResponse.items.map((item) => ({
            name: item.HistorialDate,
            Porcentaje: item.PercentInventory,
            inventory: item.Inventory,
            Rop: item.Rop,
          }));
          setLineChartDataMap((prevData) => ({
            ...prevData,
            [selectedSku]: skuData,
          }));
        } catch (error) {
          console.error("Error fetching sku data:", error);
        }
      }
    };

    fetchSkuData();
  }, [project, selectedSku]);

  useEffect(() => {
    const fetchServiceFeeData = async () => {
      if (selectedSku !== "") {
        try {
          const serviceFeeDataResponse = await get(
            `/skus?Nit=${project}&skusServiceFee=True&CodeSap=${selectedSku.split("/*-/")[0]}&limitDashServiceFee=True`
          );
          const serviceFeeData = serviceFeeDataResponse.items.map((item) => {
            const percentYes = item.PercentFee >= 75 ? item.PercentFee : null;
            const percentNo = item.PercentFee < 75 ? item.PercentFee : null;

            const countPercentYes = percentYes ? 1 : 0;
            const countPercentNo = percentNo ? 1 : 0;
            const totalCount = countPercentYes + countPercentNo;

            return {
              codeSap: item.CodeSap,
              historialDate: item.HistoryDate,
              percentFee: item.PercentFee,
              percentYes,
              percentNo,
              countPercentYes,
              countPercentNo,
              TOTAL_SERVICE_FEE: totalCount,
            };
          });

          setLineChartDataMapFee((prevData) => ({
            ...prevData,
            [selectedSku]: serviceFeeData,
          }));
        } catch (error) {
          console.error("Error fetching serviceFeeData data:", error);
        }
      }
    };

    fetchServiceFeeData();
  }, [project, selectedSku]);

  useEffect(() => {
    const fetchReceptionData = async () => {
      if (selectedReception !== "") {
        try {
          const receptionResponse = await get(
            `/receptions?Nit=${project}&receptionsHistory=True&LotNumber=${selectedReception}`
          );

          const receptionData = receptionResponse.items.map((item) => ({
            TOTAL_UNITS_RECEPTION: item.UnitsReception,
            goodUnits: item.UnitsReception - item.UnitsDefective,
            defectiveUnits: item.UnitsDefective,
            historial: item.HistorialDate,
          }));

          setBarChartDataMap((prevData) => ({
            ...prevData,
            [selectedReception]: receptionData,
          }));
        } catch (error) {
          console.error("Error fetching reception data:", error);
        }
      }
    };

    fetchReceptionData();
  }, [project, selectedReception]);

  useEffect(() => {
    const fetchQualityData = async () => {
      if (selectedReception !== "") {
        try {
          const qualityResponse = await get(
            `/qualitysReceptions?Nit=${project}&qualitysReceptionsHistory=True&LotNumber=${selectedReception}`
          );

          const qualityData = qualityResponse.items.map((item) => ({
            TOTAL_UNITS_QUALITY_RECEPTION: item.UnitsQualitysReception,
            goodUnits2:
              item.UnitsQualitysReception - item.UnitsQualitysDefective,
            defectiveUnits2: item.UnitsQualitysDefective,
            historial: item.HistorialDate,
          }));

          setBarChartDataMap2((prevData) => ({
            ...prevData,
            [selectedReception]: qualityData,
          }));
        } catch (error) {
          console.error("Error fetching quality data:", error);
        }
      }
    };

    fetchQualityData();
  }, [selectedReception]);

  useEffect(() => {
    const fetchDocData = async () => {
      if (selectedReception !== "") {
        try {
          const docDataResponse = await get(
            `/documentsManagements?Nit=${project}&documentsManagementsHistory=true&LotNumber=${selectedReception}`
          );
          const docData = docDataResponse.items.map((item) => {
            const totalOptions = [
              "receipt",
              "remission",
              "qualityCertificate",
              "safetySheet",
            ].length;
            const siCount = [
              "Receipt",
              "Remission",
              "QualityCertificate",
              "SafetySheet",
            ].reduce((count, key) => {
              return count + (item[key] === "Si" ? 1 : 0);
            }, 0);

            return {
              historial: item.HistorialDate,
              porcentajeSi: ((siCount / totalOptions) * 100).toFixed(2),
            };
          });

          setLineChartDataMapDoc((prevData) => ({
            ...prevData,
            [selectedReception]: docData,
          }));
        } catch (error) {
          console.error("Error fetching document data:", error);
        }
      }
    };

    fetchDocData();
  }, [selectedReception]);

  // const CustomTooltip = ({ active, payload }) => {
  //   if (active && payload && payload.length) {
  //     return (
  //       <div className="custom-tooltip">
  //         <p>{`${payload[0].payload.historial}: ${payload[0].value}%`}</p>
  //       </div>
  //     );
  //   }
  //   return null;
  // };

  return (
    <div style={{ padding: "16px", margin: "0 auto" }}>
      <h2 style={{ textAlign: "center", color: "#146284" }}>Dashboard</h2>
      {/* <div style={{ border: "1px solid #ddd", padding: "16px" }}> */}
        <Select
          showSearch
          defaultValue="Seleccione un Código Sap"
          style={{ width: "100%", marginBottom: "16px" }}
          optionFilterProp="children"
          onChange={(e) => setSelectedSku(e)}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {skus.map((sku) => (
            <Option
              key={sku.CodeSap}
              value={`${sku.CodeSap}/*-/${sku.Nit}`}
              title={sku.Nit}
            >
              {`${sku.CodeSap} - ${sku.Nit}`}
            </Option>
          ))}
        </Select>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Card
              title="Inventario/ROP VS Fecha"
              headStyle={{ textAlign: "center", color: "#146284" }}
            >
              <div style={{ width: "100%", overflowX: "auto" }}>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={lineChartDataMap[selectedSku] || []}>
                    <XAxis dataKey="name" interval="preserveStartEnd" />
                    <YAxis type="number" domain={[0, 100]} />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="inventory"
                      name="Inventario"
                      stroke="#64B5F6"
                    />
                    <Line
                      type="monotone"
                      dataKey="Rop"
                      name="ROP"
                      stroke="#FF5733"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Tasa de servicio"
              headStyle={{ textAlign: "center", color: "#146284" }}
            >
              <div style={{ width: "100%", overflowX: "auto" }}>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={lineChartDataMapFee[selectedSku] || []}>
                    <XAxis dataKey="historialDate" interval="preserveStartEnd" />
                    <YAxis
                      type="number"
                      domain={[-0.1, 1.1]}
                      ticks={[0, 1]}
                      tick={{ fontWeight: "bold" }}
                      tickFormatter={(value) =>
                        value === 0 ? "No cumplio" : "Cumplio"
                      }
                    />
                    <Tooltip
                      formatter={(value, name, props) => [props.payload[0]?.payload.historialDate]}
                    />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="countPercentYes"
                      name="Cumplimiento"
                      stroke="#64B5F6"
                    />
                    {/* <Line
          type="monotone"
          dataKey="countPercentNo"
          name="No cumplio"
          stroke="#FF5733"
        /> */}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>
        </Row>
      {/* </div> */}
      {/* <div style={{ border: "1px solid #ddd", padding: "16px", marginTop:"16px" }}> */}
        <Select
          showSearch
          defaultValue="Seleccione un Lote"
          style={{ width: "100%", marginBottom: "16px", marginTop: "16px" }}
          optionFilterProp="children"
          onChange={(e) => {
            setSelectedReception(e);
          }}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {receptions.map((reception) => (
            <Option key={reception.LotNumber} value={reception.LotNumber}>
              {`Lote: ${reception.LotNumber} / Código Sap: ${
                reception.CodeSap
              } / Nit: ${reception.Nit}`}
            </Option>
          ))}
        </Select>
        <Row gutter={[16, 16]} align="middle" justify="center">
          <Col xs={24} md={12}>
            <Card
              title="Recepciones"
              headStyle={{ textAlign: "center", color: "#146284" }}
            >
              <div style={{ width: "100%", overflowX: "auto" }}>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={BarChartDataMap[selectedReception]}>
                    <XAxis
                      dataKey="historial"
                      interval="preserveStartEnd"
                      height={10}
                      tick={{ display: "none" }}
                    />
                    <YAxis type="number" domain={[0, TOTAL_UNITS_RECEPTION]} />
                    <Tooltip />
                    <Legend />
                    <Bar
                      dataKey="TOTAL_UNITS_RECEPTION"
                      name="Total de unidades"
                      fill="#146284"
                    />
                    <Bar
                      dataKey="goodUnits"
                      name="Unidades buenas"
                      fill="#82ca9d"
                    />
                    <Bar
                      dataKey="defectiveUnits"
                      name="Unidades defectuosas"
                      fill="#FF5733"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Calidad en Proceso"
              headStyle={{ textAlign: "center", color: "#146284" }}
            >
              <div style={{ width: "100%", overflowX: "auto" }}>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={BarChartDataMap2[selectedReception]}>
                    <XAxis
                      dataKey="historial"
                      interval="preserveStartEnd"
                      height={10}
                      tick={{ display: "none" }}
                    />
                    <YAxis
                      type="number"
                      domain={[0, TOTAL_UNITS_QUALITY_RECEPTION]}
                    />
                    <Tooltip />
                    <Legend />
                    <Bar
                      dataKey="TOTAL_UNITS_QUALITY_RECEPTION"
                      name="Total de unidades"
                      fill="#146284"
                    />
                    <Bar
                      dataKey="goodUnits2"
                      name="Unidades buenas"
                      fill="#82ca9d"
                    />
                    <Bar
                      dataKey="defectiveUnits2"
                      name="Unidades defectuosas"
                      fill="#FF5733"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Gestión Documental"
              headStyle={{ textAlign: "center", color: "#146284" }}
            >
              <div style={{ width: "100%", overflowX: "auto" }}>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={lineChartDataMapDoc[selectedReception] || []}>
                    <XAxis dataKey="historial" interval="preserveStartEnd" />
                    <YAxis
                      type="number"
                      domain={[0, 100]}
                      tickFormatter={(value) => `${value}%`}
                    />
                    <Tooltip/>
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="porcentajeSi"
                      name="%"
                      stroke="#64B5F6"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>
        </Row>
      {/* </div> */}
      
    </div>
  );
};
